import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ExitChecklistService } from '../services/exit-checklist.service';
import { ExitFormService } from '../services/exit-form.service';
import { OffboardingService } from '../services/offboarding.service';
import { PersonalDetailsService } from '../services/personal-details.service';

@Component({
  selector: 'app-offboarding',
  templateUrl: './offboarding.component.html',
  styleUrls: ['./offboarding.component.css']
})
export class OffboardingComponent implements OnInit {
  offboardingList;
  currentPageNo = 1;
  perPage = 25;
  sNo =1;
  totalItems;
  currentUser;
  isAdmin:boolean = false;
  isManager:boolean = false;
  isManagerNotSubmitted:boolean = false;
  isManagerNotVerified:boolean = false;
  isManagerFillYourForm:boolean = false;
  isManagerSubmitted:boolean = false;
  isManagerVerified:boolean = false;
  isSystemAdmin:boolean = false;

  constructor(
    private offboardingService: OffboardingService,
    private spinnerService: Ng4LoadingSpinnerService,
    private ex_form_service:ExitFormService,
    private ex_check_service:ExitChecklistService,
    private personal_details_service:PersonalDetailsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.spinnerService.show();
    this.getOffboardingList(this.currentPageNo);

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.isAdmin = this.currentUser && this.currentUser.roles.includes("admin") ? true : false;
    this.isManager = this.currentUser && this.currentUser.roles.includes("manager") ? true : false;
    this.isSystemAdmin = this.currentUser && this.currentUser.roles.includes("reimbursement_manager") ? true : false;

    sessionStorage.clear();
  }

  getOffboardingList(pgNo:number){
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.spinnerService.show();
    this.offboardingService.getOffboardingList(pgNo).subscribe(data=>{
      this.offboardingList = data.body.data;

      for (const offboarding of this.offboardingList) {
      //Button enable/disable changing in Manager's offboarding page 
        if (
          offboarding.personal_details_status === "notSubmitted" ||
          offboarding.exit_interview_status === "notSubmitted" ||
          offboarding.exit_checklist_employee_status === "notSubmitted"
        ) {
          this.isManagerNotSubmitted = true;
          this.isManagerNotVerified = false;
          this.isManagerFillYourForm = false;
          this.isManagerSubmitted = false;
          this.isManagerVerified = false;
        }

        if (
          (offboarding.personal_details_status === "submitted" ||
            offboarding.exit_interview_status === "submitted") &&
          offboarding.exit_checklist_employee_status === "submitted"
        ) {
          this.isManagerNotSubmitted = false;
          this.isManagerNotVerified = true;
          this.isManagerFillYourForm = false;
          this.isManagerSubmitted = false;
          this.isManagerVerified = false;
        }

        if (
          offboarding.personal_details_status === "verified" &&
          offboarding.exit_interview_status === "verified" &&
          offboarding.exit_checklist_employee_status === "submitted"
        ) {
          this.isManagerNotSubmitted = false;
          this.isManagerNotVerified = false;
          this.isManagerFillYourForm = true;
          this.isManagerSubmitted = false;
          this.isManagerVerified = false;
        }

        if (
          offboarding.exit_checklist_reporting_manager_status === "submitted"
        ) {
          this.isManagerNotSubmitted = false;
          this.isManagerNotVerified = false;
          this.isManagerFillYourForm = false;
          this.isManagerSubmitted = true;
          this.isManagerVerified = false;
        }

        if (
          offboarding.exit_checklist_reporting_manager_status === "verified"
        ) {
          this.isManagerNotSubmitted = false;
          this.isManagerNotVerified = false;
          this.isManagerFillYourForm = false;
          this.isManagerSubmitted = false;
          this.isManagerVerified = true;
        }
      }

      this.totalItems = data.body.pagination.total;

      if(this.currentPageNo > 1){
        let perPageIndex
        perPageIndex = (this.currentPageNo - 1 )* this.perPage
        this.sNo = perPageIndex + 1
      }else{
        this.sNo = 1
      }
      this.spinnerService.hide();
    }
    ,
      (err) => {
        this.spinnerService.hide();
        console.log("Get Offboarding List Error:", err);
      }
    )
  }

  goTo_pd(url,id){
    this.pd_answers(id,url+id)
  }

  goTo_ex(url,id){
    
    this.ex_intrw_answers(id,url+id)
  }

  goTo_exCheck(url,id){
    
    this.ex_check_answers(id,url+id)
  }

  //storing answers
  ss_data:any;
  ss_data_ex:any;
  ss_data_int:any;

  check_manager:any;
  check_systemAdmin:any;
  getall:any;
  get_hr:any;

  pd_answers(id,url){
    this.spinnerService.show();
    this.personal_details_service.getAnswer(id).subscribe(
      (data) => {
        this.ss_data = data.body

        this.ss_data.questions.forEach(ele => {
          let arr_c = [];
          if(!!ele.options){

            ele.options.forEach(element => {
               arr_c.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_c;
          }
        });
        this.spinnerService.hide();
        sessionStorage.setItem('pd_answer',JSON.stringify(this.ss_data.questions))
        this.router.navigate([url])
      },
      (err) => {
        console.log("Get Personal Details Answer Error:", err);
      }
    );
  }

  ex_intrw_answers(id,url) {
    this.spinnerService.show();
    this.ex_form_service.getAnswerEx(id).subscribe(
      (data) => {
        this.ss_data_int = data.body

        this.ss_data_int.questions.forEach(ele => {
          let arr_c1 = [];
          if(!!ele.options){

            ele.options.forEach(element => {
               arr_c1.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_c1;
          }
        });
        this.spinnerService.hide();
        sessionStorage.setItem('ex_int_answer',JSON.stringify(this.ss_data_int.questions))
        this.router.navigate([url])
      },
      (err) => {
        console.log("Get Exit Interview Form Answer Error:", err);
      }
    );
  }

  ex_check_answers(id,url) {
    this.spinnerService.show();
    this.ex_check_service.getAnswerExitChecklist(id).subscribe(
      (data) => {
         this.ss_data_ex = data.body

         this.ss_data_ex.questions.forEach(ele => {
          let arr_c2 = [];
          if(!!ele.options){
            ele.options.forEach(element => {
               arr_c2.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_c2;
          }
        });
        this.spinnerService.hide();
        sessionStorage.setItem('ex_check_answer',JSON.stringify(this.ss_data_ex.questions))
        this.router.navigate([url])
        
      },
      (err) => {
        console.log("Get ExitChecklist Answer Error:", err);
      }
    );
  }

  getManagerQues(url,id) {
    this.spinnerService.show();
    this.ex_check_service.getReportManagerQuestions().subscribe(
      (data) => {
        this.check_manager = data.body
      
        this.check_manager.data.forEach(ele => {
            ele.required = true;
            let arr_c = [];
            if(!!ele.options){
              ele.options.forEach(element => {
                 arr_c.push( { 'key': element, 'label': element } )
            });
            ele.options = arr_c;
            }
          });
          this.spinnerService.hide();
        sessionStorage.setItem('check_manager',JSON.stringify(this.check_manager.data))
        this.router.navigate([url+id])
      },
      (err) => {
        console.log("Get Reporting Manager Questions Error:", err);
      }
    );
  }

  getSyestemAdminQuestions(url,id) {
    this.spinnerService.show();
    this.ex_check_service.getSystemAdminQuestions().subscribe(
      (data) => {
        this.check_systemAdmin = data.body;
        this.check_systemAdmin.data.forEach(ele => {
          ele.required = true;
          let arr_c = [];
          if(!!ele.options){
            ele.options.forEach(element => {
               arr_c.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_c;
          }
        });

        this.spinnerService.hide();
        sessionStorage.setItem('check_sysadmin',JSON.stringify(this.check_systemAdmin.data))
        this.router.navigate([url+id])
      },
      (err) => {
        console.log("Get System Admin Questions Error:", err);
      }
    );
  }

  get_all(url,datas) {

    var arr = []
    var arrhr = []
    var arrad = []
    var arrmn = []

    this.spinnerService.show();
    this.ex_check_service.getAllChecklists(datas).subscribe(
      async data => {
        this.getall = data.body

        await this.getall.questions.forEach(ele => {
          ele.required = true;
          let arr_c = [];
          
          if(!!ele.options){
            ele.options.forEach(element => {
            arr_c.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_c;
          }
          
        });
        this.spinnerService.hide();
        this.getall.questions.forEach(element => {
          if(element.category === 'exit_checklist_employee'){
            arr.push(element.id);

            let foundIndex = this.getall.questions.findIndex((element) => element['category'] === 'exit_checklist_employee');
            this.getall.questions[foundIndex]['title'] = 'Exit Checklist Employee';
          }
          else if (element.category === "exit_checklist_reporting_manager"){
            arrmn.push(element.id)

            let foundIndex = this.getall.questions.findIndex((element) => element['category'] === 'exit_checklist_reporting_manager');
            this.getall.questions[foundIndex]['title'] = 'Exit Checklist Manager';
          }
          else if (element.category === "exit_checklist_system_admin"){
            arrad.push(element.id)

            let foundIndex = this.getall.questions.findIndex((element) => element['category'] === 'exit_checklist_system_admin');
            this.getall.questions[foundIndex]['title'] = 'Exit Checklist System Admin';
          }
          else if (element.category === "exit_checklist_hr"){
            arrhr.push(element.id)

            let foundIndex = this.getall.questions.findIndex((element) => element['category'] === 'exit_checklist_hr');
            this.getall.questions[foundIndex]['title'] = 'Exit Checklist HR';
          }          
        });

        sessionStorage.setItem('check_all',JSON.stringify(this.getall.questions))
        
        this.router.navigate([url+datas])
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Get All Checklists Error:", err);
      }
    );
  }

  get_hr_ques(url,id){
    this.spinnerService.show();
    this.ex_check_service.getExitChecklistHR().subscribe(
      (data) => {
        this.get_hr = data.body

        this.get_hr.data.forEach(ele => {
          ele.required = true;
          let arr_chr = [];
          
          if(!!ele.options){
            ele.options.forEach(element => {
            arr_chr.push( { 'key': element, 'label': element } )
          });
          ele.options = arr_chr;
          }
          
        });

        this.spinnerService.hide();
        sessionStorage.setItem('ques_hr',JSON.stringify(this.get_hr.data))

        this.router.navigate([url+id])
        
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Get Exit Checklist HR Error:", err);
      }
    );

  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/offboarding.component.ts